export default __webpack_public_path__ + "static/media/Maduro-1.0a315269.png";